var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTilesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.00195312,
    width: 11.002,
    height: 11.002,
    rx: 1.75842,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.51465,
    y: 1.51562,
    width: 1.89711,
    height: 1.89711,
    rx: 0.58614,
    fill: "#006AB3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.51465,
    y: 4.55078,
    width: 1.89711,
    height: 1.89711,
    rx: 0.58614,
    fill: "#006AB3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.51465,
    y: 7.58594,
    width: 1.89711,
    height: 1.89711,
    rx: 0.58614,
    fill: "#006AB3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.55078,
    y: 1.51562,
    width: 1.89711,
    height: 1.89711,
    rx: 0.58614,
    fill: "#006AB3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4.55078,
    y: 4.55078,
    width: 1.89711,
    height: 1.89711,
    rx: 0.58614,
    fill: "#006AB3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 4.55078,
    y: 7.58594,
    width: 1.89711,
    height: 1.89711,
    rx: 0.58614,
    fill: "#006AB3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 7.58496,
    y: 1.51562,
    width: 1.89711,
    height: 1.89711,
    rx: 0.58614,
    fill: "#006AB3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 7.58496,
    y: 4.55078,
    width: 1.89711,
    height: 1.89711,
    rx: 0.58614,
    fill: "#006AB3"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 7.58496,
    y: 7.58594,
    width: 1.89711,
    height: 1.89711,
    rx: 0.58614,
    fill: "#006AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTilesIcon);
export default __webpack_public_path__ + "static/media/tiles-icon.1500a6f327b0ed7ec674d0b2f8ace109.svg";
export { ForwardRef as ReactComponent };